module.exports = __webpack_public_path__ + "img/pocket.b49632e4.png";